let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8MWTi")).then(() => parcelRequire('6pg7V'));